import { Link, useLocation } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

const Footer = () => {
  const location = useLocation();
  
  // Hide footer on admin routes
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <footer data-testid="footer" className="bg-card border-t border-white/5">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6 flex flex-col items-center text-center">
            <Link to="/" className="block">
              <img 
                src="https://customer-assets.emergentagent.com/job_laguerre-tailor/artifacts/nrobby08_handwritten%20signature%20logo%20V2%20black.png" 
                alt="Laguerre" 
                className="h-28 w-auto"
              />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Custom tailoring for the modern day renaissance man.
            </p>
            <a
              href="https://instagram.com/laguerre.co"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              <Instagram strokeWidth={1.5} size={18} />
              @laguerre.co
            </a>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h4 className="mono-text text-foreground">Navigation</h4>
            <ul className="space-y-3">
              {[
                { name: "Home", path: "/" },
                { name: "Collections", path: "/collections" },
                { name: "How It Works", path: "/how-it-works" },
                { name: "About", path: "/about" },
                { name: "Contact", path: "/contact" },
                { name: "Booking", path: "/booking" },
                { name: "Manage Appointment", path: "/manage-appointment" }
              ].map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    data-testid={`footer-link-${item.name.toLowerCase().replace(/ /g, "-")}`}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors line-animation"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-6">
            <h4 className="mono-text text-foreground">Services</h4>
            <ul className="space-y-3">
              {["Custom Suits", "Custom Shirts", "Evening Wear", "Alterations"].map((item) => (
                <li key={item}>
                  <span className="text-sm text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-6">
            <h4 className="mono-text text-foreground">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Instagram strokeWidth={1.5} size={18} className="text-primary" />
                <a href="https://instagram.com/laguerre.co" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  @laguerre.co
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail strokeWidth={1.5} size={18} className="text-primary" />
                <a href="mailto:hello@laguerre.co" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  hello@laguerre.co
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="mono-text text-muted-foreground text-[10px]">
            © {new Date().getFullYear()} laguerre.co — All Rights Reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/faq" className="mono-text text-muted-foreground text-[10px] hover:text-primary transition-colors">
              FAQ
            </Link>
            <Link to="/policy" className="mono-text text-muted-foreground text-[10px] hover:text-primary transition-colors">
              Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
